// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-11-10T09:33:30Z                      #

// ##############################################################


/**
 * Vyjmenované hodnoty pro sign_Level.
 */
enum EnumSignLevel {
    QUALIFIED = 'QUALIFIED', 
    GUARANTEED = 'GUARANTEED'
};
export default EnumSignLevel;

/**
 * Mapa enumu na objekt s podrobnostmi o enumu.
 */
const params = {
    [EnumSignLevel.QUALIFIED]: {caption: ''},
    [EnumSignLevel.GUARANTEED]: {caption: ''}
};

/**
 * Načtení popisku enumu.
 * @return popisek enumu
 */
export function getCaption(value) {
    return params[value].caption;
}
